import { render, staticRenderFns } from "./DepartmentPage.vue?vue&type=template&id=f63aaf88&scoped=true&"
import script from "./DepartmentPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63aaf88",
  null
  
)

export default component.exports